import type { DriftIssue, Severity } from "../types.js";

const SEVERITY_COST: Record<Severity, number> = {
  error: 10,
  warning: 2,
  info: 0,
};

// Cap deductions per severity so warnings can't tank the score like errors do
const MAX_DEDUCTION: Record<Severity, number> = {
  error: 100,   // errors are uncapped — 10 errors = score 0
  warning: 30,  // warnings capped at 30 points total
  info: 0,      // info is free
};

/** Compute drift score from 0-100. Starts at 100, deducts per issue with severity caps. */
export function computeScore(issues: DriftIssue[]): number {
  const deductions: Record<Severity, number> = { error: 0, warning: 0, info: 0 };

  for (const issue of issues) {
    deductions[issue.severity] += SEVERITY_COST[issue.severity];
  }

  let total = 0;
  for (const sev of ["error", "warning", "info"] as Severity[]) {
    total += Math.min(deductions[sev], MAX_DEDUCTION[sev]);
  }

  return Math.max(0, Math.min(100, 100 - total));
}
